/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import TransactionRepository from '../../repositories/Admin/TransactionRepository';
import { createRestSlice } from '../../utils/RestSlice';

const transactionsRestSlice = createRestSlice({
  resource: 'transaction',
  repository: TransactionRepository,
  slices: ['loadTransaction', 'loadTransactions', 'updateTransaction'],
});

const initialState = {
  ...transactionsRestSlice.initialState,
};

const transactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    ...transactionsRestSlice.reducers,
  },
});

export default transactionsSlice.reducer;

export const transactionsRestHooks = transactionsRestSlice.hooks(
  transactionsSlice,
  ['admin', 'TransactionsSlice']
);
